// The time changes (time.history) as HistoryFeed's entries: who changed which day, what was struck and
// what it is now, why, and paid before → after. Shared by the Timesheet and Hours.
import type { HistoryEntry, HistoryFilter } from '../components/HistoryFeed/HistoryFeed.tsx';
import type { TimeChangeView } from './timesheet-view.ts';

export const CHANGE_FILTERS: HistoryFilter[] = [{ id: 'all', label: 'All changes' }];

export function changeEntries(changes: TimeChangeView[]): HistoryEntry[] {
  return changes.map((c) => {
    const what = c.diff.map((d) => d.what).join('; ');
    const tail = [c.why ? `Why: ${c.why}` : '', c.paid ?? ''].filter(Boolean).join(' · ');
    return {
      id: c.id,
      at: c.at,
      kind: 'edit',
      head: (
        <>
          <b>{c.who}</b> changed {c.day}: {what}
        </>
      ),
      text: `${c.who} ${c.day} ${what} ${tail}`,
      ...(c.diff.length === 1 ? { diff: [c.diff[0]!.was, c.diff[0]!.now] as [string, string] } : {}),
      ...(tail ? { detail: tail } : {}),
    };
  });
}
